import type { FC } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Expand01Icon } from '@/components/ui/icons'

interface ExpandImageButtonProps {
	onClick: () => void
}

export const ExpandImageButton: FC<ExpandImageButtonProps> = ({ onClick }) => (
	<ButtonLegacy
		className='show-on-hover absolute top-8 right-8'
		onClick={onClick}
		shape='square'
		size='sm'
		tabIndex={-1}
		type='button'
		variant='secondary'
	>
		<Expand01Icon />
	</ButtonLegacy>
)

ExpandImageButton.displayName = 'ExpandImageButton'
